import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #E3E3E3;
  min-height: calc(100vh - 80px);
  border-radius: 12px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 15px 10px;
  }
`;

export default PageContainer; 